import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface MessageContentOperation {
  type: string;
  display_name: string;
  dealer_values: any[];
  dealer_specials: any[];
  footer_image: any[];
}

export interface MessageContent {
  _id: string;
  dealer_id: string;
  operations: MessageContentOperation[];
  created_at: string;
  updated_at: string;
}

export interface MessageContentListResponse {
  data: MessageContent[];
  totalPages: number;
  currentPage: number;
  totalDocuments: number;
}

class MessageContentService {
  static ENDPOINT = 'api/v2/message-content';

  static async getMessageContent(dealerId: string): Promise<APIResponseType> {
    if (!dealerId) throw new Error('Dealer ID is required to fetch message content');
    try {
      const response = await apiService.get<APIResponseType>(
        `${this.ENDPOINT}?dealer_id=${dealerId}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async initializeMessageContent(dealerId: string): Promise<APIResponseType> {
    if (!dealerId) throw new Error('Dealer ID is required to initialize message content');
    try {
      const response = await apiService.post<APIResponseType>(
        `${this.ENDPOINT}/initialize`,
        { dealer_id: dealerId },
      );
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateMessageContent(
    id: string,
    operations: Array<{
      type: string;
      display_name: string;
      dealer_values: string[];
      dealer_specials: string[];
      footer_image: string[];
    }>,
  ): Promise<APIResponseType> {
    if (!id) throw new Error('Message Content ID is required to update');
    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${id}`, {
        operations,
      });
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default MessageContentService;
